import { NotEmptyString } from "../../../../Validation/Validation";
import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaProperty } from "../Schema";

export const AddressSchema: ISchema = {
    displayName: "Address",
    props: [
        {
            name: 'companyStreet',
            displayName: 'Street',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function
        } as ISchemaProperty,
        {
            name: 'address1',
            displayName: 'Line 1',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function
        } as ISchemaProperty,
        {
            name: 'address2',
            displayName: 'Line 2',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'city',
            displayName: 'City',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function
        } as ISchemaProperty,
        {
            name: 'county',
            displayName: 'County',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'country',
            displayName: 'Country',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'zip',
            displayName: 'Zip',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function
        } as ISchemaProperty
    ]
}
